import { Link, NavLink, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NCCC_LOGO } from "../lib/assets";

const NAV = [
  { to: "/", label: "Manifesto", testid: "nav-link-home" },
  { to: "/releases", label: "Releases", testid: "nav-link-releases" },
  { to: "/portals", label: "Portals", testid: "nav-link-portals" },
  { to: "/affiliates", label: "Affiliates", testid: "nav-link-affiliates" },
  { to: "/submit", label: "Submit", testid: "nav-link-submit" },
];

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <header
      data-testid="site-nav"
      className="relative z-40 border-b border-[color:var(--nccc-border)] bg-[color:var(--nccc-bg)]/85 backdrop-blur"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img
            src={NCCC_LOGO}
            alt="NCCC"
            className="w-12 h-12 object-contain"
          />
          <div className="flex flex-col leading-tight">
            <span className="label-accent">NCCC</span>
            <span className="font-display text-[15px] tracking-tight text-[color:var(--nccc-cream)]">
              New Counter Culture Collective
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={({ isActive }) =>
                `label transition-colors hover:text-[color:var(--nccc-ochre)] ${
                  isActive ? "text-[color:var(--nccc-ochre)]" : ""
                }`
              }
              end={item.to === "/"}
            >
              <span className="hex-bullet" style={{ opacity: pathname === item.to ? 1 : 0.45 }} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          className="md:hidden nccc-btn-ghost p-2 border border-[color:var(--nccc-border)]"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[color:var(--nccc-border)] bg-[color:var(--nccc-bg)]">
          <div className="px-6 py-5 flex flex-col gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-${item.testid}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `label py-2 ${
                    isActive ? "text-[color:var(--nccc-ochre)]" : "text-[color:var(--nccc-cream)]"
                  }`
                }
                end={item.to === "/"}
              >
                <span className="hex-bullet" />
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
